// When this device last secured an account (see secureAccountOn). Once proven
// and cleaned, nobody else can open a session on it — no password, no code
// without the inbox, no Google without a matching identity — so re-checking on
// every launch is three requests of defence in depth; once a week is plenty.

export const SECURE_EVERY_MS = 7 * 24 * 60 * 60 * 1000;

const key = (userId: string): string => `aybuben:secured:${userId}`;

export function securedRecently(userId: string, now: number): boolean {
	let raw: string | null = null;
	try {
		raw = globalThis.localStorage?.getItem(key(userId)) ?? null;
	} catch {
		return false;
	}
	const at = Number(raw);
	return raw !== null && Number.isFinite(at) && now - at < SECURE_EVERY_MS;
}

export function markSecured(userId: string, now: number): void {
	try {
		globalThis.localStorage?.setItem(key(userId), String(now));
	} catch {
		/* the next launch checks again */
	}
}
